// extracted by mini-css-extract-plugin
module.exports = {"rangeAreaStyle":"_3swFWnhfM_84U8Nx5W0tMh"};